import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const OtherSchemesForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    gpName: 'धामणी',
    taluka: 'मिरज',
    district: 'सांगली',
    meetingDate: '2026-05-01',
    resolutionNo: '12',
    approvalDate: '2026-05-14',
    fundYear: '2020-21',
    terms: '1) वरील कामे ग्रा.प. ही शासनाच्या नियमानुसार करेल.'
  });

  const [workEntries, setWorkEntries] = useState([
    { workName: 'sangli road', schemeName: 'निवडा', amount: '20000', location: 'sangli', remark: '-' }
  ]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleWorkChange = (index, e) => {
    const { name, value } = e.target;
    const updatedEntries = [...workEntries];
    updatedEntries[index][name] = value;
    setWorkEntries(updatedEntries);
  };

  const addNewEntry = () => {
    setWorkEntries([...workEntries, { workName: '', schemeName: 'निवडा', amount: '', location: '', remark: '-' }]);
  };

  const removeEntry = () => {
    if (workEntries.length > 1) {
      setWorkEntries(workEntries.slice(0, -1));
    }
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="min-h-screen bg-[#f4f6f9] py-5 px-2 font-sans">
      <style>
        {`
          @media print {
            @page {
              size: A4;
              margin: 10mm;
            }
            body {
              visibility: hidden;
              background: white !important;
            }
            #printable-area {
              visibility: visible;
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              padding: 5mm;
              display: block !important;
              color: black !important;
            }
            .no-print {
              display: none !important;
            }
          }
        `}
      </style>

      {/* Main Form */}
      <div className="w-full bg-white border border-gray-300 shadow-sm rounded-sm overflow-x-auto no-print">
        <div className="bg-[#fff9e6] py-2 px-4 border-b border-gray-300 min-w-[1000px] flex justify-between items-center gap-2">
          <h2 className="text-[#b71c1c] text-left shrink text-[14px] sm:text-[17px] font-bold flex items-center  gap-2">
            <span className="text-blue-600 text-xl leading-none">✹</span> प्रशासकीय मान्यता आदेश- इतर योजना
          </h2>
          <button onClick={() => navigate(-1)} className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold py-1 px-4 rounded text-sm no-print whitespace-nowrap shrink-0">
              मागे जा
            </button>
        </div>

        <div className="p-5 min-w-[1000px]">
          <div className="grid grid-cols-3 gap-x-10 gap-y-4 mb-6">
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">ग्रामपंचायतीचे नाव</label>
              <select name="gpName" value={formData.gpName} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm bg-white outline-none">
                <option value="">ग्रामपंचायत निवडा</option>
                <option value="धामणी">धामणी</option>
              </select>
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">मासिक सभा दिनांक</label>
              <input type="date" name="meetingDate" value={formData.meetingDate} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none" />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">ठराव क्र.*</label>
              <input type="text" name="resolutionNo" value={formData.resolutionNo} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none" />
            </div>

            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">प्रशासकीय मान्यता दिनांक*:</label>
              <input type="date" name="approvalDate" value={formData.approvalDate} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none" />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">निधी मंजुरी वर्ष*</label>
              <select name="fundYear" value={formData.fundYear} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm bg-white outline-none">
                <option value="">वर्ष निवडा</option>
                <option value="2020-21">2020-21</option>
              </select>
            </div>
          </div>

          <div className="space-y-4 border-t pt-6">
            <div className="grid grid-cols-5 gap-3">
              <label className="text-[13px] font-bold text-[#333] text-center">कामाचे नाव</label>
              <label className="text-[13px] font-bold text-[#333] text-center">योजनेचे नाव</label>
              <label className="text-[13px] font-bold text-[#333] text-center">प्रशासकीय मान्यता रक्कम*</label>
              <label className="text-[13px] font-bold text-[#333] text-center">कामाचे ठिकाण:</label>
              <label className="text-[13px] font-bold text-[#333] text-center">शेरा:</label>
            </div>

            {workEntries.map((entry, index) => (
              <div key={index} className="grid grid-cols-5 gap-3 items-center">
                <input name="workName" value={entry.workName} onChange={(e) => handleWorkChange(index, e)} placeholder="कामाचे नाव" className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none" />
                <select name="schemeName" value={entry.schemeName} onChange={(e) => handleWorkChange(index, e)} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm bg-white outline-none">
                  <option value="निवडा">योजनेचा प्रकार निवडा</option>
                  <option value="जनसुविधा">जनसुविधा</option>
                  <option value="नागरी सुविधा">नागरी सुविधा</option>
                </select>
                <input name="amount" value={entry.amount} onChange={(e) => handleWorkChange(index, e)} placeholder="प्रशासकीय मान्यता रक्कम" className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none" />
                <input name="location" value={entry.location} onChange={(e) => handleWorkChange(index, e)} placeholder="कामाचे ठिकाण" className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none" />
                <input name="remark" value={entry.remark} onChange={(e) => handleWorkChange(index, e)} placeholder="शेरा" className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none" />
              </div>
            ))}
          </div>

          <div className="mt-8 flex flex-col gap-1">
            <label className="text-[13px] font-bold text-[#333]">अटी व शर्ती :*</label>
            <textarea name="terms" value={formData.terms} onChange={handleChange} rows="3" className="border border-[#ccc] rounded-sm px-3 py-2 text-sm outline-none resize-none"></textarea>
          </div>

          <div className="mt-8 flex flex-wrap gap-4 justify-center">
            <button onClick={handlePrint} className="bg-[#00a65a] text-white px-12 py-1.5 rounded-sm text-sm font-semibold shadow-sm hover:bg-[#008d4c]">Save</button>
            <button className="bg-[#f39c12] text-white px-8 py-1.5 rounded-sm text-sm font-semibold shadow-sm hover:bg-[#e08e0b]">Generate Document</button>
            <button onClick={addNewEntry} className="bg-[#3c8dbc] text-white px-10 py-1.5 rounded-sm text-sm font-semibold shadow-sm hover:bg-[#357fa8]">नवीन जोडा</button>
            <button onClick={removeEntry} className="bg-[#f39c12] text-white px-8 py-1.5 rounded-sm text-sm font-semibold shadow-sm hover:bg-[#e08e0b]">निवडलेले काढून टाका</button>
          </div>

          <div className="mt-6 border border-gray-300 rounded-sm min-h-[300px] bg-white"></div>

          <div className="mt-4">
            <button className="bg-[#f4f4f4] border border-[#ddd] text-[#444] px-5 py-1.5 rounded-sm text-xs flex items-center gap-2 hover:bg-[#e8e8e8]">
              <span>🖨️</span> Print
            </button>
          </div>
        </div>
      </div>

      {/* Printable Area */}
      <div id="printable-area" className="hidden print:block font-serif text-black bg-white p-10">
        <div className="flex justify-between items-start mb-10">
          <div className="text-[14px] leading-relaxed">
            <p className="font-bold underline mb-1">वाचा:</p>
            <p>1) महाराष्ट्र ग्रामपंचायत अधिनियम</p>
            <p>2) ग्रामपंचायत {formData.gpName} वार्षिक विकास आराखडा सन {formData.fundYear}</p>
            <p>3) ग्रा.पं.कार्यालय {formData.gpName} मासिक सभा दिनांक: {formData.meetingDate} ठराव क्र.{formData.resolutionNo}</p>
          </div>
          <div className="text-right text-[15px] font-bold">
            <p>ग्रामपंचायत कार्यालय: {formData.gpName}</p>
            <p>ता. {formData.taluka} जि. {formData.district}</p>
            <p>दिनांक: {formData.approvalDate}</p>
          </div>
        </div>

        <div className="text-center mb-8">
          <h3 className="text-[18px] font-extrabold underline">प्रशासकीय मान्यता आदेश:</h3>
        </div>

        <p className="text-[15px] leading-loose mb-6">
          कार्यालय ग्रामपंचायत {formData.gpName} ता. {formData.taluka} जि. {formData.district} प्राप्त अधिकाराचा वापर करून वरील संदर्भानुसार इतर योजना निधी सन {formData.fundYear} अंतर्गत कामासाठी पुढीलप्रमाणे कामास व रकमेस प्रशासकीय मान्यता आदेश देत आहे.
        </p>

        <table className="w-full border-collapse border border-black text-[13px] mb-8">
          <thead>
            <tr className="bg-gray-50 font-bold text-center">
              <th className="border border-black px-2 py-1">अ.क्र.</th>
              <th className="border border-black px-2 py-1">कामाचे नाव</th>
              <th className="border border-black px-2 py-1">योजनेचे नाव</th>
              <th className="border border-black px-2 py-1">कामाचे ठिकाण</th>
              <th className="border border-black px-2 py-1">प्रशासकीय मान्यता रक्कम(रुपये)</th>
              <th className="border border-black px-2 py-1">शेरा</th>
            </tr>
          </thead>
          <tbody>
            {workEntries.filter(e => e.workName.trim() !== '').map((entry, idx) => (
              <tr key={idx}>
                <td className="border border-black px-2 py-1 text-center">{idx + 1}</td>
                <td className="border border-black px-2 py-1">{entry.workName}</td>
                <td className="border border-black px-2 py-1">{entry.schemeName}</td>
                <td className="border border-black px-2 py-1">{entry.location}</td>
                <td className="border border-black px-2 py-1 text-center font-bold">{entry.amount}</td>
                <td className="border border-black px-2 py-1">{entry.remark}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="mb-16">
          <p className="font-bold underline mb-2">अटी व शर्ती:</p>
          <p className="text-[14px]">{formData.terms}</p>
        </div>

        <div className="flex justify-between items-end mt-32 pr-10 pl-10 font-bold">
          <div className="text-center">
            <p>ग्रामसेवक /ग्रामविकास अधिकारी</p>
          </div>
          <div className="text-center">
            <p>सरपंच</p>
          </div>
        </div>
        <div className="text-right font-bold mt-4 pr-10">
          <p>ग्रामपंचायत {formData.gpName}</p>
        </div>
      </div>
    </div>
  );
};

export default OtherSchemesForm;
